import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import createRootReducer from '../reducers';
import createHelpers from './createHelpers';
import createLogger from './logger';
import { loadingBarMiddleware } from 'react-redux-loading-bar'


export default function configureStore(initialState, config) {
  const helpers = createHelpers(config);
  const { apolloClient } = config;

  const middleware = [
    thunk.withExtraArgument(helpers),
    apolloClient.middleware()
  ];

  /*
  loadingBarMiddleware({
    promiseTypeSuffixes: ['START', 'SUCCESS', 'ERROR']
  })
  */

  let enhancer;

  if (__DEV__) {
    middleware.push(createLogger());

    // https://github.com/zalmoxisus/redux-devtools-extension#redux-devtools-extension
    let devToolsExtension = f => f;
    if (process.env.BROWSER && window.devToolsExtension) {
      devToolsExtension = window.devToolsExtension();
    }

    enhancer = compose(
      applyMiddleware(...middleware),
      devToolsExtension,
    );
  } else {
    enhancer = applyMiddleware(...middleware);
  }

  const rootReducer = createRootReducer({
    apolloClient,
  });

  /**
   * This function checks if the app state is saved in localStorage
   */
  /* const loadState = () => {
  /* const loadState = () => {
    try {
      if( typeof window === 'undefined' ) return {};

      //return {}; //disable state storage
      
      // Load the data saved in localStorage, against the key 'app_state'
      const serialisedState = window.localStorage.getItem('appState');

      if( !serialisedState ) return {};

      // Unserialise the saved state, and return it.
      return JSON.parse(serialisedState);
    } catch (err) {
      return {};
    }
  }; */

  /**
   * Tunnel in using an array element in the form ['prop', 'subProp', 'subSubProp', ['endPointProp1', 'endPointProp2', ...]]
   * where the endPointProps are the props to store
   */
  /* const storedStateItems = [['book', ['data', 'bookDetails']]]; // , 'form'

  const loadedState = loadState();
  const combinedState = initialState;

  if( Object.keys(loadedState).length != 0 ) {
    storedStateItems.map(prop => {
      if( Array.isArray(prop) ) {
        let currentLoadedStateProp = loadedState;
        let currentCombinedStateProp = combinedState;
        prop.some(subProp => {
          if( Array.isArray(subProp) ) { // We are at the end; subProp is an array of endpoint sub props to load
            subProp.forEach(e => {
              if( typeof currentLoadedStateProp[e] !== 'undefined' ) {
                currentCombinedStateProp[e] = currentLoadedStateProp[e];
              }
            });
            return true; // I.e. stop
          }
          else if( typeof currentCombinedStateProp[subProp] !== 'undefined' ) {
            if( typeof currentLoadedStateProp[subProp] === 'undefined' ) {
              return true; //I.e. stop: the subProp is not stored
            }
            currentCombinedStateProp = currentCombinedStateProp[subProp];
            currentLoadedStateProp = currentLoadedStateProp[subProp];
            return false; // I.e. continue
          }
          else {
            currentCombinedStateProp[subProp] = {};
          }
          return true; // I.e. stop: the subProp is not in state
        })
      }
      else if( typeof state[prop] !== 'undefined' ) {
        storeState[prop] = state[prop];
      }
    });
  } */

  /**
  * This is where you create the app store
  */
  // See https://github.com/rackt/redux/releases/tag/v3.1.0
  const store = createStore(rootReducer, initialState, enhancer);

  /**
   * Add a change listener to the store, and invoke our saveState function defined above.
   */
  /* if( typeof window !== 'undefined' ) {
    store.subscribe(() => {
      const state = store.getState();
      const storeState = {};
      storedStateItems.map(prop => {
        if( Array.isArray(prop) ) {
          let currentStateProp = state;
          let currentStoreStateProp = storeState;
          prop.some(subProp => {
            if( Array.isArray(subProp) ) { // We are at the end; subProp is an array of endpoint sub props to store
              subProp.forEach(e => {
                if( typeof currentStateProp[e] !== 'undefined' ) {
                  currentStoreStateProp[e] = currentStateProp[e];
                }
              });
              return true; // I.e. stop
            }
            else if( typeof currentStateProp[subProp] !== 'undefined' ) {
              currentStateProp = currentStateProp[subProp];
              currentStoreStateProp[subProp] = {};
              currentStoreStateProp = currentStoreStateProp[subProp];
              return false; // I.e. continue
            }
            return true; // I.e. stop: the subProp is not in state
          })
        }
        else if( typeof state[prop] !== 'undefined' ) {
          storeState[prop] = state[prop];
        }
      });
      //if( typeof state.form.BookingForm !== 'undefined' ) storeState.form.BookingForm = state.form.BookingForm;

      window.localStorage.setItem('appState', JSON.stringify(storeState));
      
      //saveState(store.getState());
    });
  } */

  // Hot reload reducers (requires Webpack or Browserify HMR to be enabled)
  if (__DEV__ && module.hot) {
    module.hot.accept('../reducers', () =>
      // Don't forget to remove `()` if you change reducers back to normal rootReducer.
      // eslint-disable-next-line global-require            // eslint-disable-next-line global-require
      store.replaceReducer(require('../reducers').default({ apolloClient })),
    );
  }

  return store;
}



// WEBPACK FOOTER //
// src/store/configureStore.js